import DesignEditorPrimaryControls from './DesignEditorPrimaryControls';

export default DesignEditorPrimaryControls;
